
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3_1952)","fill":"#262626"}},[_c('path',{attrs:{"d":"M21.636 28H1.273C.573 28 0 27.427 0 26.727V6.364c0-.7.573-1.273 1.273-1.273h5.09v2.545H2.546v17.819h17.819v-3.819h2.545v5.091c0 .7-.573 1.273-1.273 1.273z"}}),_c('path',{attrs:{"d":"M26.727 25.454h-5.09c-.7 0-1.273-.572-1.273-1.272V7.636h-14c-.7 0-1.273-.572-1.273-1.272V1.273C5.09.573 5.664 0 6.364 0h20.363C27.427 0 28 .573 28 1.273v22.909c0 .7-.573 1.273-1.273 1.273zM22.91 22.91h2.546V2.545H7.636v2.546h14c.7 0 1.273.573 1.273 1.273v16.545z"}}),_c('path',{attrs:{"d":"M22.91 21.636h-2.546v-14h-14V5.091h15.272c.7 0 1.273.573 1.273 1.273v15.272z"}}),_c('path',{attrs:{"d":"M16.546 12.727H6.364c-.7 0-1.273-.572-1.273-1.272 0-.7.573-1.273 1.273-1.273h10.181c.7 0 1.273.573 1.273 1.273s-.573 1.272-1.273 1.272zM16.546 17.818H6.364c-.7 0-1.273-.573-1.273-1.273s.573-1.272 1.273-1.272h10.181c.7 0 1.273.572 1.273 1.273 0 .7-.573 1.272-1.273 1.272zM16.546 22.91H6.364c-.7 0-1.273-.574-1.273-1.274 0-.7.573-1.272 1.273-1.272h10.181c.7 0 1.273.572 1.273 1.272 0 .7-.573 1.273-1.273 1.273z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3_1952"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h28v28H0z"}})])])])
          )
        }
      }
    